var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62646 7.82593L3.62646 6.82593L4.62646 7.82593",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3735 7.85338L12.3735 8.85338L11.3735 7.85338",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0575 10.1823C12.2847 10.3135 12.3643 10.6056 12.2122 10.8193C11.6056 11.6716 10.744 12.3157 9.74592 12.6545C8.59725 13.0444 7.34601 13.0034 6.2253 12.5392C5.1046 12.075 4.19087 11.2192 3.65436 10.1313C3.18816 9.18591 3.0344 8.12129 3.2081 7.08971C3.25166 6.83102 3.51451 6.68077 3.76791 6.74867C4.0213 6.81657 4.16871 7.07699 4.13093 7.33659C4.01339 8.14417 4.14218 8.97256 4.50639 9.7111C4.94096 10.5923 5.68108 11.2855 6.58885 11.6615C7.49662 12.0376 8.51013 12.0707 9.44055 11.7549C10.2203 11.4902 10.8971 10.9955 11.3851 10.3414C11.5419 10.1311 11.8303 10.0512 12.0575 10.1823Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94251 5.49698C3.71533 5.36582 3.6357 5.07371 3.78783 4.85999C4.39444 4.00773 5.25596 3.36365 6.25408 3.02483C7.40275 2.63491 8.65399 2.67587 9.7747 3.14009C10.8954 3.6043 11.8091 4.4601 12.3456 5.54804C12.8118 6.4934 12.9656 7.55802 12.7919 8.5896C12.7483 8.84829 12.4855 8.99854 12.2321 8.93064C11.9787 8.86274 11.8313 8.60232 11.8691 8.34272C11.9866 7.53514 11.8578 6.70675 11.4936 5.96821C11.059 5.08698 10.3189 4.39378 9.41115 4.01777C8.50338 3.64176 7.48987 3.60858 6.55945 3.92442C5.77969 4.18911 5.10286 4.6838 4.61493 5.33795C4.45808 5.54824 4.1697 5.62815 3.94251 5.49698Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/Replace.caafb1f7c976de01befca9e4d1cd548d.svg";
export { ForwardRef as ReactComponent };